import { render } from "./CompletedQuestions.vue?vue&type=template&id=3423fd05&scoped=true"
import script from "./CompletedQuestions.vue?vue&type=script&lang=js"
export * from "./CompletedQuestions.vue?vue&type=script&lang=js"

import "./CompletedQuestions.vue?vue&type=style&index=0&id=3423fd05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3423fd05"]])

export default __exports__